// src/components/settings/shared/TabNavigation.jsx - FIXED
import React from 'react';

export const TabNavigation = ({ tabs, activeTab, onTabChange, hasChanges = false }) => {
  return (
    <div className="w-64 border-r border-gray-200 bg-gray-50 overflow-y-auto">
      <div className="p-4">
        <nav className="space-y-1">
          {tabs.map((tab) => {
            const IconComponent = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors text-sm ${
                  activeTab === tab.id
                    ? 'bg-blue-100 text-blue-700 border border-blue-200 shadow-sm'
                    : 'hover:bg-gray-100 text-gray-700'
                }`}
              >
                <IconComponent className="h-4 w-4 flex-shrink-0" />
                <span className="font-medium">{tab.label}</span>
                {tab.badge && (
                  <span className="ml-auto bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                    {tab.badge}
                  </span>
                )}
                {tab.id === activeTab && hasChanges && (
                  <div className="ml-auto w-2 h-2 bg-orange-400 rounded-full" />
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};